import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { ToastUtils } from "../../../helper/toast.helper";
import { XeroService } from "../../../services/xero.service";

export interface XeroInvoice {
    invoice_id: string;
    number: string | null;
    type: string | null;
    status: string | null;
    date: string | null;
    due_date: string | null;
    total: number | null;
    amount_due: number | null;
    amount_paid: number | null;
    currency: string | null;
    reference: string | null;
}

/**
 * AV-17974: invoice history for a Xero-linked account or organisation, the
 * Xero counterpart of the Stripe "Campaign Subscription" charge list.
 */
let XeroInvoicesDialogComponent = {
    selector: "vcXeroInvoicesDialog",
    templateUrl:
        "/angular/components/admin/dialogs/xero-invoices-dialog.component.html",
    bindings: {
        target: "<",
    },
    controller: class XeroInvoicesDialogController {
        // * bindings for typescript compiler *
        public target: { account?: any; organisation?: any };
        // ************************************
        public invoices: XeroInvoice[] | null = null;
        public contact: string | null = null;
        public error: string | null = null;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private service: XeroService;

        constructor(
            XeroService: XeroService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.service = XeroService;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
        }

        $onInit(): void {
            this.service.invoices(this.target).then(
                (response: object) => {
                    const json = response["data"];
                    this.contact = json.data.contact;
                    this.invoices = json.data.invoices;
                },
                (failure: any) => {
                    const payload =
                        failure && failure.data && failure.data.data;
                    this.error =
                        (payload && payload.message) ||
                        "Could not load invoices from Xero.";
                    this.invoices = [];
                }
            );
        }

        invoiceUrl(invoice: XeroInvoice): string {
            return XeroService.invoiceUrl(invoice.invoice_id);
        }

        statusClass(invoice: XeroInvoice): string {
            switch (invoice.status) {
                case "PAID":
                    return "ec-pill-success";
                case "AUTHORISED":
                    return invoice.amount_due && invoice.amount_due > 0
                        ? "ec-pill-warning"
                        : "ec-pill-neutral";
                case "VOIDED":
                case "DELETED":
                    return "ec-pill-error";
                default:
                    return "ec-pill-neutral";
            }
        }

        money(value: number | null, currency: string | null): string {
            if (value === null || value === undefined) return "—";
            return value.toFixed(2) + (currency ? " " + currency : "");
        }

        dismiss(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("admin")
    .component(
        XeroInvoicesDialogComponent.selector,
        XeroInvoicesDialogComponent
    );
